var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryBadge = function SvgPrimaryBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#primary-badge_svg__a)",
    d: "M3.106 0h12.739c.072 0 .134.047.15.116a.14.14 0 0 1-.084.164c-1.249.56-1.952 1.875-1.952 3.047v12.525a.68.68 0 0 1-.238.53L7.397 21.8a.826.826 0 0 1-1.083-.005L.232 16.382A.68.68 0 0 1 0 15.858V2.939C0 1.321 1.396 0 3.106 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3 10 3.95-4.95L10.9 10l-3.95 4.95z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary-badge_svg__a",
    x1: 0,
    x2: 20.93,
    y1: 22,
    y2: 6.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })))));
};
export { SvgPrimaryBadge as ReactComponent };
export default __webpack_public_path__ + "fonts/primary-badge-db5c55d1298b02539988452f7228b7c1.svg";